<template lang="">
  <div>
    <LaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana></LaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana>
  </div>
</template>
<script>
import LaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana from '../components/laudos/formularios/exames/transvaginalUteroParaAvaliacaoDeReservaOvariana/LaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana.vue';
export default {
  components: {
    LaudoTransvaginalUteroParaAvaliacaoDeReservaOvariana,
  },
};
</script>
<style lang=""></style>
